<template>
  <v-layout wrap row>
    <template v-if="!disabled">
      <v-dialog width="500" max-width="100vw" v-model="changeCompanyDialog">
        <og-company-selector></og-company-selector>
      </v-dialog>
      <v-flex xs12 sm6>
        <v-btn v-if="isMultiCompany" color="primary" @click="changeCompanyDialog = true">
          <v-icon>mdi-reload</v-icon>
          {{ $t('Cambiar entre mis negocios') }}
        </v-btn>
      </v-flex>
      <v-flex xs12 sm6 class="text-sm-right">
        <v-btn color="primary" @click="addCompany">
          <v-icon>mdi-plus</v-icon>
          {{ $t('Agregar negocio a Opendata') }}
        </v-btn>
      </v-flex>
    </template>

    <v-flex xs12>
      <aru-auto-form
        v-if="formReady"
        :disabled="disabled"
        v-model="company"
        :form-configuration="config['companyForm']"
        :submit-text="$t('Siguiente')"
        :saving-data="savingData"
        :dismiss-text="$t('Volver atrás')"
        :dismissButton="!disabled"
        :validate-before-submit="validateBeforeSubmit"
        @dismiss="cancelForm"
        @submit="companySubmit"
        @validationErrors="companyErrors"
      ></aru-auto-form>
    </v-flex>
  </v-layout>
</template>

<script>
import OgCompanySelector from '@/components/commons/OgCompanySelector.vue';
import AruAutoForm from '@/components/commons/form/AruAutoForm.vue';
import apiCtrl from '@/services/aru-services/aru-api.service.js';

export default {
  components: {
    OgCompanySelector,
    AruAutoForm,
  },
  props: {
    config: {
      type: Object,
    },
    model: {
      type: Object,
    },
    disabled: {
      type: Boolean,
    },
    validateBeforeSubmit: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      changeCompanyDialog: false,
      company: {},
      formReady: false,
      savingData: false,
    };
  },
  mounted() {
    if (this.model && this.model.id) {
      console.log({ theModel: this.model });
      this.formReady = false;
      this.company = this.model;
      this.formReady = true;
    } else {
      this.presetCompany();
    }
  },
  computed: {
    currentCompany() {
      return this.$store.getters['currentCompany'];
    },
    isMultiCompany() {
      return this.$store.getters['companies'].length > 1;
    },
    currentCompanyAddress() {
      const addArr = [];

      if (this.currentCompany['VIAPUB']) {
        addArr.push(this.currentCompany['VIAPUB']);
      }

      if (this.currentCompany['NUMERO']) {
        addArr.push('Num. ' + this.currentCompany['NUMERO']);
      }

      if (this.currentCompany['ESCALE']) {
        addArr.push('Esc. ' + this.currentCompany['ESCALE']);
      }

      if (this.currentCompany['PISO']) {
        addArr.push('Piso ' + this.currentCompany['PISO']);
      }

      if (this.currentCompany['PUERTA']) {
        addArr.push('Prta. ' + this.currentCompany['PUERTA']);
      }

      return addArr.join(', ');
    },
  },
  methods: {
    companySubmit(data) {
      if (this.disabled) {
        this.$emit('companySaved', this.company);
      } else {
        this.createOrUpdateCompanyData(data);
      }
    },

    createOrUpdateCompanyData(company) {
      this.savingData = true;

      let route = '/opendata-form';
      let method = 'post';
      this.company.status = 'draft';
      if (this.company.hasOwnProperty('id') && this.company.id) {
        route = route + '/' + this.company.id;
        method = 'put';
        company.id = this.company.id;
      }
      apiCtrl[method](route, company).then(res => {
        this.company = res.data.data;
        this.savingData = false;
        this.$emit('companySaved', this.company);
      });
    },

    cancelForm() {
      this.$router.push('/opendata/form/wellcome');
    },

    presetCompany() {
      this.formReady = false;
      console.log('presetCompany');
      const company = {
        clavedat: this.currentCompany ? this.currentCompany['CLAVEDAT'] : null,
        name: this.currentCompany ? this.currentCompany['APELNOM'] : null,
        cif: this.currentCompany ? this.currentCompany['DNICIF'] : null,
        address: this.currentCompanyAddress,
        city: this.currentCompany ? this.currentCompany['MUNICI'] : null,
        postal_code: this.currentCompany ? this.currentCompany['CODPOS'] : null,
        province: this.currentCompany ? this.currentCompany['PROVIN'] : null,
        phone: this.currentCompany ? this.currentCompany['TELEFO'] : null,
        email: this.currentCompany ? this.currentCompany['E_MAIL'] : null,
        activity: '',
      };

      this.company = company;
      this.formReady = true;
    },
    companyErrors(data) {},

    addCompany() {
      this.formReady = false;

      const company = {
        clavedat: null,
        name: null,
        cif: null,
        address: null,
        city: null,
        postal_code: null,
        province: null,
        phone: null,
        email: null,
        activity: null,
      };

      for (const field in company) {
        if (company.hasOwnProperty(field)) {
          const value = company[field];
          this.$set(this.company, field, value);
        }
      }
      this.formReady = true;
    },
  },
};
</script>

<style></style>
